import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Head from 'next/head';
import styles from '../assets/css/Home.module.css';
import Layout from "../components/sidebarPro";
import Header from "../components/home/header/Header";
import Table from "../components/home/table/Table";
import Stories from "../components/home/storiesSecction/Stories";
import Articles from "../components/home/articles/Articles";
import Movies from "../components/home/movies/Movies2";
import Footer from "../components/footer/Footer";
import Slider from "../components/home/carousel/Slider";
import Link from "next/link";
import React, { useContext, useEffect, useState } from "react";
import OnlinePLayers from "../components/home/onlinePlayers";
import { home } from "../api/requests";
import useTranslation from 'next-translate/useTranslation';
import TokenError from "../components/modals/tokenError";
var img2 = '../../images/home/carousel/img/504.png';
var img3 = '../../images/home/carousel/img/1100-app.png';
var img4 = '../../images/home/carousel/img/english-1&2.png';
var img6 = '../../images/home/carousel/img/gre-app.png';
var img7 = '../../images/home/carousel/img/ilets.png';
var img8 = '../../images/home/carousel/img/longman.png';
var img9 = '../../images/home/carousel/img/phonetics-blue.png';
var img10 = '../../images/home/carousel/img/phonetics-green.png';
var img11 = '../../images/home/carousel/img/phonetics-pink.png';
var img12 = '../../images/home/carousel/img/prospect-1.png';
var img13 = '../../images/home/carousel/img/prospect-2.png';
var img14 = '../../images/home/carousel/img/prospect-3.png';
var img15 = '../../images/home/carousel/img/tofel.png';
var img16 = '../../images/home/carousel/img/v1.png';
var img17 = '../../images/home/carousel/img/v2.png';
var img18 = '../../images/home/carousel/img/v3.png';
export var __N_SSG = true;
export default function Home() {
  var _useState = useState(false),
      show2 = _useState[0],
      setShow2 = _useState[1];

  var toggle2 = function toggle2() {
    return setShow(!show2);
  };

  var sliderSetting1 = {
    className: styles.slider1,
    items: [img2, img3, img4, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18]
  };
  var sliderSetting2 = {
    className: styles.slider2,
    items: [img2, img3, img4, img6, img7, img8, img9]
  };
  var sliderSetting3 = {
    className: styles.slider3,
    items: [img10, img11, img12, img13, img14, img15, img16, img17, img18]
  };

  var _useState2 = useState(null),
      homeData = _useState2[0],
      setHomeData = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var startClicked = function startClicked() {
    localStorage.setItem('homeFirstTimeUser', 1);
  };

  useEffect(function () {
    home().then(function (res) {
      var number;
      setHomeData(res.data); // console.log("res",res.data)
    })["catch"](function (err) {
      return console.log(err);
    });
  }, []);
  return /*#__PURE__*/_jsxs(Layout, {
    page: "home",
    children: [/*#__PURE__*/_jsx(TokenError, {
      show: show2,
      toggle: toggle2,
      redirect: 'home'
    }), /*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: isRTL ? 'دنیای واژگان' : 'World of Words'
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsxs("main", {
      style: {
        fontFamily: isRTL ? 'Yekan' : 'Helvetica'
      },
      dir: isRTL ? 'rtl' : 'ltr',
      children: [/*#__PURE__*/_jsxs("div", {
        className: "position-relative",
        children: [/*#__PURE__*/_jsx(Header, {
          totalUsersNumber: homeData ? homeData.TotalUsers : "88298"
        }), /*#__PURE__*/_jsx(Link, {
          href: '/start',
          children: /*#__PURE__*/_jsx("a", {
            children: /*#__PURE__*/_jsx("div", {
              className: "shadow-lg ".concat(styles.btnStart),
              onClick: function onClick() {
                return startClicked();
              },
              children: t('home:start')
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-4 ".concat(styles.smallScreenPadding),
        children: [/*#__PURE__*/_jsxs("h3", {
          className: "".concat(styles.text, " ").concat(styles.homeTitles),
          children: [t('home:playWith'), /*#__PURE__*/_jsxs("span", {
            children: [" ", homeData ? homeData.TotalUsers : 88298, " "]
          }), t('home:learners')]
        }), /*#__PURE__*/_jsx(Table, {}), /*#__PURE__*/_jsx("h3", {
          className: "".concat(styles.text, " ").concat(styles.homeTitles),
          children: t('home:learnWordsFrom')
        })]
      }), /*#__PURE__*/_jsx(Slider, {
        setting: sliderSetting1
      }), /*#__PURE__*/_jsx(Slider, {
        setting: sliderSetting2
      }), /*#__PURE__*/_jsx(Slider, {
        setting: sliderSetting3
      }), /*#__PURE__*/_jsx(Stories, {
        homeData: homeData
      }), /*#__PURE__*/_jsxs("div", {
        className: "position-relative",
        children: [/*#__PURE__*/_jsx(Articles, {}), /*#__PURE__*/_jsx(Link, {
          href: '/wow-stories/getReady',
          children: /*#__PURE__*/_jsx("a", {
            children: /*#__PURE__*/_jsx("div", {
              className: "shadow-lg ".concat(styles.btnWriteYourStory, " ").concat(isRTL ? styles.btnWriteYourStoryFa : ''),
              children: t('home:writeYourStory')
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Movies, {}), /*#__PURE__*/_jsx(OnlinePLayers, {}), /*#__PURE__*/_jsx(Footer, {
        hasBackToTop: true
      })]
    })]
  });
}